import axios from 'axios';
import Cookies from 'universal-cookie';
import i18n from '../i18n.js';
import {showErrorEv} from '../models/infoModel/index.js';
import {setAuthStatusEv} from '../models/authModel/index.js';

const cookies = new Cookies();

export default function api (auth = true) {
    const instance = axios.create({baseURL: API_URL, withCredentials: true});

    if (auth) {
        const access_token = cookies.get('access_token')
        instance.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
    }

    instance.interceptors.request.use((config) => {
        const csrfToken = cookies.get('csrftoken')
        if (csrfToken) {
            config.headers['X-CSRFToken'] = csrfToken
        }
        config.withCredentials = true
        return config;
    })

    instance.interceptors.response.use((response) => {
        return response;
    }, async (error) => {
        if (error.request.status === 0) {
            showErrorEv({summary: i18n.t("Ошибка"), detail: i18n.t('Нет сети или сервер не отвечает'),});
        } else if (error.response.status === 401) {
            cookies.remove('access_token', {path: '/'})
            cookies.remove('refresh_token', {path: '/'})
            setAuthStatusEv(false)
            window.location.reload()
        } else if (error.response.status === 404) {
            showErrorEv({
                summary: 404,
                detail: i18n.t('Не найдено')
            });
        } else {
            showErrorEv({
                summary: error.response.status === 500 ? i18n.t('Серверная ошибка') : error.response.status,
                detail: `${error.message}`
            });
        }
        return Promise.reject(error);
    });

    return instance;
}